import {useSearchParams} from 'react-router-dom';

const useEditorDevice = () => {
  const [searchParams] = useSearchParams();
  const device = searchParams.get('device') ?? 'desktop';
  return device as 'desktop' | 'mobile';
};

export default useEditorDevice;
